import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["minInput", "maxInput", "minSlider", "maxSlider", "track"]
  static values = { min: { type: Number, default: 0 }, max: { type: Number, default: 100 } }

  connect() {
    this.updateTrack()
  }

  updateFromMinSlider() {
    const minVal = parseInt(this.minSliderTarget.value)
    const maxVal = parseInt(this.maxSliderTarget.value)
    
    if (minVal > maxVal - 5) {
      this.minSliderTarget.value = maxVal - 5
    }
    
    this.minInputTarget.value = this.minSliderTarget.value
    this.updateTrack()
  }

  updateFromMaxSlider() {
    const minVal = parseInt(this.minSliderTarget.value)
    const maxVal = parseInt(this.maxSliderTarget.value)
    
    if (maxVal < minVal + 5) {
      this.maxSliderTarget.value = minVal + 5
    }
    
    this.maxInputTarget.value = this.maxSliderTarget.value
    this.updateTrack()
  }

  updateFromMinInput() {
    let val = parseInt(this.minInputTarget.value) || 0
    val = Math.max(this.minValue, Math.min(val, this.maxValue))
    this.minSliderTarget.value = val
    this.updateTrack()
  }

  updateFromMaxInput() {
    let val = parseInt(this.maxInputTarget.value) || this.maxValue
    val = Math.max(this.minValue, Math.min(val, this.maxValue))
    this.maxSliderTarget.value = val
    this.updateTrack()
  }

  updateTrack() {
    const min = parseInt(this.minSliderTarget.value)
    const max = parseInt(this.maxSliderTarget.value)
    const range = this.maxValue - this.minValue
    
    const minPercent = ((min - this.minValue) / range) * 100
    const maxPercent = ((max - this.minValue) / range) * 100
    
    this.trackTarget.style.left = `${minPercent}%`
    this.trackTarget.style.width = `${maxPercent - minPercent}%`
  }
}
